import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MembershipManagementComponent } from './membership-management.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ApiClient } from '../../core/api-client.service';
import { MbscModule, MbscOptionsService } from '@mobiscroll/angular';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EditCompanyInfoModalComponent } from './modals/edit-company-info-modal.component';
import { AddEditAddressModalComponent } from './modals/add-edit-address-modal.component';
import { EditCompanyLiaisonModalComponent } from './modals/edit-company-liaison.component';
import { EditCompanyPaymentInfoModalComponent } from './modals/edit-company-payment-info-modal.component';
import { EditCompanyDirectoryInfoModalComponent } from './modals/edit-company-directory-info-modal.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    MembershipManagementComponent,
    EditCompanyInfoModalComponent,
    AddEditAddressModalComponent,
    EditCompanyLiaisonModalComponent,
    EditCompanyPaymentInfoModalComponent,
    EditCompanyDirectoryInfoModalComponent
  ],
  imports: [
    CommonModule
    , BrowserModule
    , FormsModule
    , ReactiveFormsModule    
    , NgxMaskDirective
    , MbscModule
    , NgxMaskPipe
      , EditorModule
    , NgbTooltipModule
  ],
  providers: [ApiClient
    ,MbscOptionsService 
, provideNgxMask()],
})
export class MembershipManagementModule { }
